import { Icon } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { Alert, AlertTitle } from '@mui/material';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { PaymentFailedRestrictionDialogContentProps as Props } from './types';

export const PaymentFailedRestrictionDialogContent = memo(
  ({ className }: Props) => {
    return (
      <Styled.Wrapper
        className={classnames(
          'PaymentFailedRestrictionDialogContent',
          className
        )}
        sx={SX.root}
        gap={1.5}
      >
        <Alert icon={false} severity="warning">
          Your account is currently restricted due to an unpaid invoice. To
          restore full access, please update your billing information and settle
          your outstanding balance.
        </Alert>
        <Alert severity="default" icon={<Icon name="problem" size={20} />}>
          <AlertTitle>Important Note</AlertTitle>
          If you're having trouble or need assistance, our support team is
          available to help.
        </Alert>
      </Styled.Wrapper>
    );
  }
);

PaymentFailedRestrictionDialogContent.displayName =
  'PaymentFailedRestrictionDialogContent';
